"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteUsersInvite = void 0;
var React = require("react");
var immer_1 = require("immer");
var stateless_forms_1 = require("./forms/stateless_forms");
var buttons_1 = require("../buttons");
var utils_1 = require("../../utils");
var initial = {
    full_name: undefined,
    email: undefined,
    telephone: undefined,
    company: undefined,
};
var SiteUsersInvite = function (_a) {
    var inviteUser = _a.inviteUser;
    var _b = __read(React.useState(initial), 2), form_data = _b[0], setFormData = _b[1];
    var fields = [
        {
            name: "full_name",
            label: gettext("Name"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXTAREA,
            required: true,
            value: form_data.full_name || "",
        },
        {
            name: "email",
            label: gettext("E-mail"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.EMAIL,
            required: true,
            value: form_data.email || "",
        },
        {
            name: "telephone",
            label: gettext("Phone"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            required: true,
            value: form_data.telephone || "",
        },
        {
            name: "company",
            label: gettext("Company"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXTAREA,
            required: true,
            value: form_data.company || "",
        },
    ];
    function isFormValid() {
        return (form_data.full_name &&
            form_data.full_name.length > 0 &&
            form_data.email &&
            (0, utils_1.validateEmail)(form_data.email) &&
            form_data.telephone &&
            form_data.telephone.length > 0 &&
            form_data.company &&
            form_data.company.length > 0);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement(stateless_forms_1.SimpleForm, { fields: fields, onUpdate: function (name, value) {
                        setFormData((0, immer_1.default)(function (draft) {
                            draft[name] = value;
                        }));
                    }, valuesObject: form_data }))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () {
                        inviteUser(form_data);
                        setFormData(initial);
                    }, disabled: !isFormValid() }, gettext("Send Invitation"))))));
};
exports.SiteUsersInvite = SiteUsersInvite;
